import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 10
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('megapack_timer_end');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (endTime < Date.now()) {
        endTime = Date.now() + (14 * 60 + 10) * 1000;
        localStorage.setItem('megapack_timer_end', endTime.toString());
      }
    } else {
      endTime = Date.now() + (14 * 60 + 10) * 1000;
      localStorage.setItem('megapack_timer_end', endTime.toString());
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = endTime - now;
      if (distance < 0) {
        const newEndTime = Date.now() + (14 * 60 + 10) * 1000;
        localStorage.setItem('megapack_timer_end', newEndTime.toString());
        setTimeLeft({
          hours: 0,
          minutes: 14,
          seconds: 10
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n < 10 ? `0${n}` : n;
  return <div className="bg-red-600 text-white py-1.5 px-4 sticky top-0 z-50 shadow-sm" style={{
    minHeight: '32px',
    contain: 'layout style'
  }} data-id="element-38">
      <div className="flex items-center justify-center gap-2 text-xs sm:text-sm font-bold" data-id="element-39">
        <span data-id="element-40">⏰ OFERTA EXPIRA EN</span>
        <span className="font-black text-base sm:text-lg tracking-wider bg-black/20 px-2 py-0.5 rounded" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-41">
          {fmt(timeLeft.hours)}:{fmt(timeLeft.minutes)}:{fmt(timeLeft.seconds)}
        </span>
        <span className="text-yellow-300 animate-pulse hidden sm:inline" data-id="element-42">
          ⚡ ÚLTIMOS CUPOS
        </span>
      </div>
    </div>;
}